const VERSION = '1.2.0';
export default VERSION;
